import React, { ReactNode } from 'react';
import { SButton, SNavButton } from './styled/SButton';
import { Loading } from '../../components';

interface ButtonProps {
    children: ReactNode;
    type?: "button" | "submit" | "reset" | undefined;
    kind?: string;
    fullWidth?: boolean;
    small?: boolean;
    disabled?: boolean;
    onClick?: () => void;
    id: string;
    to?: string;
    loading?: boolean;
}
function Button(props: ButtonProps) {
    return (
        <React.Fragment>
            {!props.to &&
                <SButton disabled={props.loading || props.disabled} id={props.id} className={'btn'} small={props.small} fullWidth={props.fullWidth} kind={ props.kind } type={ props.type } onClick={ props.onClick }>{props.loading ? <Loading color="white"/> : props.children }</SButton>
            }
            { props.to &&
                <SNavButton to={props.to} id={props.id} className={'btn'} small={props.small} kind={ props.kind } type={ props.type } onClick={ props.onClick } style={{width: props.fullWidth ? '100%' : 'auto'}}>{props.children}</SNavButton>
            }
        </React.Fragment>
    );
}

export default Button;
